/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

// eslint-disable-next-line no-restricted-imports
import type { AnalyticsConfig, AnalyticsService } from "../analytics";

export default CustomPlatform.select<() => AnalyticsService<AnalyticsConfig>>({
  web: () => require("./ga4.web").default,
  default: () => require("./ga4").default,
})();
